var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['button-view', _vm.emphasis],style:({
		..._vm.surface_style,
		..._vm.theme.typography.button,
		..._vm._style
	}),attrs:{"tabindex":_vm.enabled ? 0 : -1,"type":"text"},on:{"click":function($event){return _vm.$emit('click', $event)},"mouseenter":_vm.hover_on,"mouseleave":_vm.hover_off,"focus":_vm.focus_on,"blur":_vm.focus_off}},[(_vm.icon)?_c('svg-icon',{staticClass:"icon",style:(_vm._iconStyle),attrs:{"icon":_vm.icon}}):_vm._e(),(_vm.$slots.default)?_c('div',{staticClass:"label"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }